import service from "services/service";

export const getAlertMonitorService = (data) => (
  service('post', `v3/alertas/monitor`, { data })
)

export const getPublicAlertMonitorService = (id) => (
  service('get', `v3/alertas/monitor/${id}`)
)

export const getLastAlertsService = (data) => (
  service('get', `v3/alertas/panel`, { data })
)

export const getAlertMonitorTxnsService = (id) => (
  service('get', `v3/alertas/monitor/${id}/transacciones`)
)

export const getAllAlertsService = () => (
  service('get', `v3/alertas`)
)

export const getAlertsService = (type) => (
  service('get', `v3/alertas/${type}`)
)

export const createAlertService = (data) => (
  service('post', `v3/alertas`, { data })
)

export const updateAlertService = (id, data) => (
  service('patch', `v3/alertas/${id}`, { data })
)

export const removeAlertService = (id) => (
  service('delete', `v3/alertas/${id}`)
)

// Intermittence services
export const getIntermittences = (data) => (
  service('post', `v3/intermitencias`, { data })
)

export const getLastOpenIntermittences = () => (
  service('get', `v3/intermitencias/abierta`)
)

export const getDayIntermittences = () => (
  service('get', `v3/intermitencias/dia`)
)

export const getIntermittenceTxns = (id) => (
  service('get', `v3/intermitencias/${id}/transacciones`)
)